import { ActionType } from "../enums/action-type";
import { ActionConfig } from "@allbesmart/web-app-common";
import { UserRole } from "@allbesmart/web-app-keycloak-auth";
import { ActionCommand } from "../enums/action-command";
import { WarningMessageActionModalComponent } from "../modals/warning-message-action-modal/warning-message-action-modal.component";
import { WarningMessageModalActionConfig } from "../models/action/warning-message-modal-action-config";
import { GnbUpgradeConfigActionModalComponent } from "../modals/gnb-upgrade-config-action-modal/gnb-upgrade-config-action-modal.component";
import { FlexricUpgradeConfigActionModalComponent } from "../modals/flexric-upgrade-config-action-modal/flexric-upgrade-config-action-modal.component";
import { GnbUpgradeUhdConfigActionModalComponent } from "../modals/gnb-upgrade-uhd-config-action-modal/gnb-upgrade-uhd-config-action-modal.component";

export interface AuthActionConfig extends ActionConfig {
  rolesAssigned: UserRole[],
}

export const AVAILABLE_ACTIONS: { [key in ActionType]: AuthActionConfig[] } = {
  [ActionType.CN5G]: [
    {
      type: ActionType.CN5G,
      command: ActionCommand.UPGRADE_CN5G,
      name: 'Upgrade CN5G',
      modalComponent: WarningMessageActionModalComponent,
      modalCloseButtonColor: 'white',
      config: {message: 'CN5G will be Upgraded, this may take some time to execute.'},
      gradientColor: 'primary',
      icon: 'fa-solid fa-arrow-up-from-bracket',
      rolesAssigned: [UserRole.CN5G_UPGRADE]
    } as WarningMessageModalActionConfig,
  ],
  [ActionType.GNB]: [
    {
      type: ActionType.GNB,
      command: ActionCommand.UPGRADE_GNB,
      name: 'Upgrade gNB',
      modalComponent: GnbUpgradeConfigActionModalComponent,
      modalCloseButtonColor: 'white',
      gradientColor: 'primary',
      icon: 'fa-solid fa-arrow-up-from-bracket',
      rolesAssigned: [UserRole.GNB_UPGRADE]
    }
  ],
  [ActionType.OAIBOX]: [
    {
      type: ActionType.OAIBOX,
      command: ActionCommand.UPGRADE_OAIBOX,
      name: 'Upgrade',
      modalComponent: WarningMessageActionModalComponent,
      modalCloseButtonColor: 'white',
      config: {message: 'OAIBOX will be Upgraded, this may take some time to execute.'},
      gradientColor: 'primary',
      icon: 'fa-solid fa-arrow-up-from-bracket',
      rolesAssigned: [UserRole.OAIBOX_UPGRADE]
    } as WarningMessageModalActionConfig,
  ],
  [ActionType.FLEX_RIC]: [
    {
      type: ActionType.FLEX_RIC,
      command: ActionCommand.UPGRADE_FLEXRIC,
      name: 'Upgrade FlexRIC',
      modalComponent: FlexricUpgradeConfigActionModalComponent,
      gradientColor: 'primary',
      icon: 'fa-solid fa-arrow-up-from-bracket',
      rolesAssigned: [UserRole.ROOT]
    },
  ],
  [ActionType.USRP]: [
    {
      type: ActionType.USRP,
      command: ActionCommand.UPGRADE_UHD,
      name: 'Upgrade UHD',
      modalComponent: GnbUpgradeUhdConfigActionModalComponent,
      gradientColor: 'primary',
      icon: 'fa-solid fa-arrow-up-from-bracket',
      rolesAssigned: [UserRole.ROOT]
    },
  ],
  [ActionType.LICENSE]: [],
}
